import { FormDelete } from '../FormDelete.js';
import { ButtonUpdate } from './ButtonUpdate.js';

export const ButtonsTransaction = (props) => {
    const { entity, id } = props;
    return (
        <div className="block-buttons">
            <ButtonUpdate entity={entity} id={id} />
            <FormDelete entity={entity} id={id} />
        </div>
    )
}